import {addYears} from 'date-fns';
import {validacion} from 'lib.common';
const fechaActual = new Date();
function mayorCero(nro) {
   return nro > 0;
}
function valorEntero(nroString) {
   return parseInt(nroString);
}
//CONSTANTES IDS
export const CLIENTE = 'cliente';
export const RAZON_SOCIAL = 'razonSocial';
export const TIPO_DOC = 'tipoDoc';
export const SERIE_DOC = 'serieDoc';
export const NRO_DOC = 'nroDoc';
export const PRODUCTO = 'producto';
export const PRODUCTO_DENOMINACION = 'productoDenominacion';
export const PLAN = 'plan';
export const PLAN_DENOMINACION = 'planDenominacion';
export const ANIO = 'anio';
export const FECHA_EXPIRACION = 'fechaExpiracion';
export const FECHA_EMISION = 'fechaEmision';
export const NRO_USUARIOS = 'nroUsuarios';
export const ALMACENAMIENTO = 'almacenamiento';
export const EMAIL = 'email';
export const PRECIO = 'precio';
//ESQUEMAS
export const esquemaCampos = {
   [CLIENTE]: {valor: null, error: ''},
   [RAZON_SOCIAL]: {valor: '', error: ''},
   [TIPO_DOC]: {valor: '01', error: ''},
   [SERIE_DOC]: {valor: '', error: ''},
   [NRO_DOC]: {valor: '', error: ''},
   [PRODUCTO]: {valor: '', error: ''},
   [PRODUCTO_DENOMINACION]: {valor: '', error: ''},
   [PLAN]: {valor: '', error: ''},
   [PLAN_DENOMINACION]: {valor: '', error: ''},
   [ANIO]: {valor: fechaActual.getFullYear(), error: ''},
   [FECHA_EXPIRACION]: {valor: addYears(fechaActual, 1), error: ''},
   [FECHA_EMISION]: {valor: addYears(fechaActual, 1), error: ''},
   [NRO_USUARIOS]: {valor: 1, error: ''},
   [ALMACENAMIENTO]: {valor: 1, error: ''},
   [PRECIO]: {valor: 1, error: ''},
   [EMAIL]: {valor: '', error: ''}
};
export const esquemaValidacion = {
   [CLIENTE]: {
      requerido: true
   },
   [RAZON_SOCIAL]: {
      requerido: true
   },
   [TIPO_DOC]: {
      requerido: true
   },
   [SERIE_DOC]: {
      requerido: true
   },
   [NRO_DOC]: {
      requerido: true
   },
   [FECHA_EMISION]: {
      requerido: true
   },
   [PRODUCTO]: {
      requerido: true
   },
   [PLAN]: {
      requerido: true
   },
   [ANIO]: {
      requerido: true,
      validador: {
         regla: mayorCero,
         cast: valorEntero
      }
   },
   [FECHA_EXPIRACION]: {
      requerido: true
   },
   [NRO_USUARIOS]: {
      requerido: true,
      validador: {
         regla: mayorCero,
         cast: valorEntero
      }
   },
   [ALMACENAMIENTO]: {
      requerido: true,
      validador: {
         regla: mayorCero,
         cast: valorEntero
      }
   },
   [PRECIO]: {
      requerido: true,
      validador: {
         regla: mayorCero,
         cast: valorEntero
      }
   },
   [EMAIL]: {
      requerido: true,
      validador: {
         regla: validacion.esCorreoValido,
         error: 'Correo electrónico no válido.'
      },
      cast: valor => {
         return valor.replace(/\s/g, '');
      }
   }
};
